// eslint-disable-next-line
import { Bag } from 'baby-design/icons'
import { RegistryDiscount } from 'src/types/registryDiscount'
import css from './RegistryDiscountStatusModal.styles.scss'
import Modal from '../../../baby-design/components/Modal/Modal'
import { Header } from './DiscountInfoHeader/Header'
import {
  ShopYourRegistryButton,
  BrowseShopButton,
  AddItemFromShopButton,
} from './DiscountModalButtons/Button'
import { TermsAndConditions } from './TermsAndConditions/TermsAndConditions'
import {
  PreEligibilityDetails,
  InCohortEligibilityDetails,
  NotInCohortEligibilityDetails,
} from './DiscountContent/Content'

interface RegistryDiscountStatusModalProps {
  show: boolean
  onHide: () => void
  registryDiscount?: RegistryDiscount
}

const ActionButtons = ({ isEligible }: { isEligible?: boolean }) => (
  <>
    {isEligible ? (
      <>
        <ShopYourRegistryButton />
        <BrowseShopButton />
      </>
    ) : (
      <AddItemFromShopButton />
    )}
  </>
)

const Content = ({
  registryDiscount,
}: {
  registryDiscount: RegistryDiscount
}) => {
  const { isEligible, eligibleForMultiuseDiscount } = registryDiscount
  if (!isEligible) {
    return <PreEligibilityDetails registryDiscount={registryDiscount} />
  }
  if (eligibleForMultiuseDiscount) {
    return <InCohortEligibilityDetails registryDiscount={registryDiscount} />
  }
  return <NotInCohortEligibilityDetails registryDiscount={registryDiscount} />
}

const RegistryDiscountStatusModal = ({
  show,
  onHide,
  registryDiscount,
}: RegistryDiscountStatusModalProps) => {
  if (!registryDiscount) {
    return null
  }

  const { eligibleForMultiuseDiscount, isEligible } = registryDiscount
  return (
    <Modal showCloseButton handleClose={onHide} isOpen={show}>
      <div className={css.RegistryDiscountStatusModal__container}>
        <Header eligibleForMultiUse={eligibleForMultiuseDiscount} />
        <div className={css.RegistryDiscountStatusModal__bagIconContainer}>
          <Bag />
        </div>
        <Content registryDiscount={registryDiscount} />
        <ActionButtons isEligible={isEligible} />
        <TermsAndConditions registryDiscount={registryDiscount} />
      </div>
    </Modal>
  )
}

export default RegistryDiscountStatusModal
